import {
  faCircleXmark,
  faEdit,
  faPlus,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './index.module.css';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllLotteryBrands } from '../../../redux/features/lotteryBrand/lotteryBrandService';
import {
  editLotteryBrandDays,
  getAllLotteryBrandDay,
  getAllLotteryBrandDaysCode,
} from '../../../redux/features/lotteryBrandDay/lotteryBrandDayService';
import TableSkeleton from '../../../components/Skeleton';
import NoResultsFound from '../../../components/NoResultsFound';
import Modal from '../../../components/Modal';
import { showToast } from '../../../components/ToastMsg';

const LotteryBrandDays = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const { lotteries } = useSelector((state) => state.lottery.allLotteryBrands);
  const { isLotteryBrandDayLoading, lotteryBrandDay } = useSelector(
    (state) => state.lotteryBrandDay.allLotteryBrandDay
  );
  const { lotteryBrandDayCode, isLotteryBrandDayCodeLoading } = useSelector(
    (state) => state.lotteryBrandDay.allLotteryBrandDayCode
  );

  const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
  const [selectedLotteryId, setSelectedLotteryId] = useState(null);
  const [selectedLotteryName, setSelectedLotteryName] = useState('');
  const [reload, setReload] = useState(false);
  const [brand, setBrand] = useState('');
  const [active, setActive] = useState(true);

  const closeDeactivationModal = () => setDeactivationModalOpen(false);

  const fetchAllLotteries = useCallback(() => {
    dispatch(getAllLotteryBrands({ status: true }));
  }, [dispatch]);

  useEffect(() => {
    fetchAllLotteries();
  }, [fetchAllLotteries]);

  useEffect(() => {
    dispatch(getAllLotteryBrandDay({ status: true }));
  }, [dispatch, reload]);

  const handleLotteryBrand = (option) => {
    setBrand(option.code);
    setActive(false);
  };

  useEffect(() => {
    dispatch(getAllLotteryBrandDaysCode({ id: brand }));
  }, [dispatch, brand, reload]);

  return (
    <div className={`search-card`}>
      <div className={`search-card-header`}>
        <div className={`form-input-col`}>
          <h1 className={`form-title ${styles.headDiv}`}>
            Lottery Brand Days
          </h1>
        </div>
        <div className={`form-input-col`}>
          <div className={`form-input-group`}>
            <Dropdown
              ref={dropdownRef}
              options={lotteries}
              placeholder='Select Lottery Brand'
              onSelect={handleLotteryBrand}
            />
          </div>
        </div>
      </div>

      <div>
        {active ? (
          isLotteryBrandDayLoading ? (
            <TableSkeleton
              columns={['Image', 'Code', 'Name', 'Brand']}
              rowCount={10}
              height={20}
            />
          ) : lotteryBrandDay.length > 0 ? (
            <div className={`table-container`}>
              <table className={`table`}>
                <thead className={`thead`}>
                  <tr>
                    <th className={`theadColumnOne`}>Image</th>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Brand</th>
                  </tr>
                </thead>
                <tbody className={`tbody`}>
                  {lotteryBrandDay?.map((lottery) => (
                    <tr key={lottery.id}>
                      <td className={`tdataColumnOne`}> <img
                        src={lottery.sample_url}
                        alt={`${lottery.name} Logo`}
                        className={styles.lotteryImage}
                      /></td>
                      <td>{lottery.code}</td>
                      <td> {lottery.name} </td>
                      <td>{lottery.lottery_brand?.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <NoResultsFound />
          )
        ) : isLotteryBrandDayCodeLoading ? (
          <TableSkeleton
          columns={['Image', 'Code', 'Name', 'Brand']}
            rowCount={10}
            height={20}
          />
        ) : lotteryBrandDayCode.length > 0 ? (
          <div className={`table-container`}>
            <table className={`table`}>
              <thead className={`thead`}>
                <tr>
                <th className={`theadColumnOne`}>Image</th>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Brand</th>
                </tr>
              </thead>
              <tbody className={`tbody`}>
                {lotteryBrandDayCode?.map((lottery) => (
                  <tr key={lottery.id}>
                    <td className={`tdataColumnOne`}> <img
                        src={lottery.sample_url}
                        alt={`${lottery.name} Logo`}
                        className={styles.lotteryImage}
                      /></td>
                      <td>{lottery.code}</td>
                      <td> {lottery.name} </td>
                      <td>{lottery.lottery_brand?.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <NoResultsFound />
        )}
      </div>
    </div>
  );
};

export default LotteryBrandDays;
